export const AuthActionTypes = {
    API_RESPONSE_SUCCESS: '@@auth/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@auth/API_RESPONSE_ERROR',
    LOGIN_USER: '@@auth/LOGIN_USER',
    LOGOUT_USER: '@@auth/LOGOUT_USER',
    SIGNUP_USER: '@@auth/SIGNUP_USER',
    FORGOT_PASSWORD: '@@auth/FORGOT_PASSWORD',
    FORGOT_PASSWORD_CHANGE: '@@auth/FORGOT_PASSWORD_CHANGE',
    RESET_PASSWORD: '@@auth/RESET_PASSWORD',
    RESET: '@@auth/RESET',
    GET_DASHBOARD: '@@auth/GET_DASHBOARD',
    GET_CLIENT_MILESTONES: '@@auth/GET_CLIENT_MILESTONES',
    GET_CLIENT_TASKS: '@@auth/GET_CLIENT_TASKS',
};
